// extracted by mini-css-extract-plugin
export var slide = "TileSlider-module--slide--00ec3";
export var slideIndicator = "TileSlider-module--slideIndicator--ad51d";
export var slideIndicators = "TileSlider-module--slideIndicators--71bc9";
export var slider = "TileSlider-module--slider--8a744";
export var tileSlider = "TileSlider-module--tileSlider--0bdd3";